import { styled } from "@mui/material";
import { InputFail } from '../../../Components/Form';

export const Section = styled('section')(({ theme }) => (props) => ({
    padding: '24px  96px',
    [theme.breakpoints.down('md')]: {
        padding: '24px  48px'
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  24px ',
    },
    [theme.breakpoints.down('xs')]: {
        padding: '12px 0px',
    },
    position: 'relative'

}))
export const HeaderText = styled('h3')(({ theme }) => (props) => ({
    fontSize: "24px",
    fontWeight: "800",
    lineHeight: "29px",
    color: theme.palette.mode === "light" ?
        theme.palette.text.lightSecondary : theme.palette.text.darkSEcondary,
    margin: '0',
    padding: ' 0px 16px',

}))
export const Content = styled('section')(({ theme }) => (props) => ({
    display: 'flex',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column'
    }

}))
export const RightSection = styled('section')(({ theme }) => (props) => ({
    display: 'flex',
    gap: '10px',
    marginTop: '16px',
    padding: ' 0px 16px',
}))
export const LeftSection = styled('section')(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    flex: '1',
    padding: ' 8px 16px',
    borderLeft: '1px solid #BDBDBD',
    height: '65vh',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
        borderTop: '1px solid #BDBDBD',
        borderLeft: 'none',
    }
}))
export const RateText = styled('section')(({ theme }) => (props) => ({
    fontSize: "40px",
    fontWeight: 800,
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
}))
export const RateDisc = styled('p')(({ theme }) => (props) => ({
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: '16px',
    overflowWrap: 'break-word',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
}))
export const TitleRaeteng = styled('p')(({ theme }) => (props) => ({
    fontSize: '12px',
    fontWeight: '300',
    letterSpacing: '0em',
    display: 'flex',
    margin: '0',
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.3vw'

    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
    }
}))
export const TextDiscretion = styled('p')(({ theme }) => (props) => ({
    fontSize: '1.2vw',
    fontWeight: '600',
    letterSpacing: '0em',
    display: 'block',
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.3vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
        fontWeight: '600'
    }
}))
export const StudImage = styled('div')(({ theme }) => (props) => ({
    margin: '5px 5px 10px 5px',
    display: 'flex',
    gap: '16px',
    alignItems: 'center'
}))
export const Image = styled('img')(({ theme }) => (props) => ({
    width: '48px',
    height: '48px',
    borderRadius: '50%'
}))
export const FormStyle = styled('div')(({ theme }) => (props) => ({
    display: "flex",
    gap: '20px',
    alignItems: 'center',
    width: '40%',
    marginTop: '20px',
    marginLeft: '10vw',
    [theme.breakpoints.down("sm")]: {
        flexDirection: 'column',
        width: '100%',
        gap: '10px',
        marginLeft: '0',
    }
}))
export const CompRating = styled('div')(({ theme }) => (props) => ({
    // boxShadow: " 2px 2px 2px 2px rgba(0, 0, 0, 0.1)",
    padding: '5px'
}))
export const InputFailForm = styled(InputFail)(({ theme }) => (props) => ({
    width: '40vw',
    [theme.breakpoints.down('lg')]: {
        width: '100%'
    },
    [theme.breakpoints.down('sm')]: {
        width: '80%'
    }
}))
